import { LinearProgress, withStyles } from "@material-ui/core";

import { CustomLoadingBarStyes } from "./commonStyles";

const CustomLoadingBarComponent = withStyles(CustomLoadingBarStyes)(LinearProgress);

export default CustomLoadingBarComponent;
